<template>
	<div class="case-wrapper">
		<div class="content">
			<div class="main">
				<div class="introduce-content">精選客戶</div>
				<div class="tips">真實 LOOPSHOP 用戶回饋 網店平台推介，輕鬆開創專屬網店</div>
				<div class="left">
					<!-- <img src="" alt=""> -->
				</div>
				<div class="right">
					<!-- <img src="" alt=""> -->
				</div>
			</div>
		</div>
		<div class="custom-case-wrapper main">
			<div class="case-content" v-for="(item, index) in caseList" :key="index">
				<div class="case-img"><img :src="item.bigimg" alt=""></div>
				<div class="case-conten-right">
					<img class="image" :src="item.smallimg" alt="">
					<div class="quote">{{ item.content }}</div>
					<div class="author-info">
						<div class="author">{{ item.title }}</div>
						<router-link to="/register">
							<div class="trial">免費試用開店</div>
						</router-link>
					</div>
				</div>
			</div>
			<div v-if="showMoreBtn" @click="getCaseListAll" class="more-button">查看更多</div>
		</div>
		<div class="share-wrapper main">
			<div class="title">商戶體驗分享</div>
			<img src="@/assets/images/next_button.png" class="next" alt="">
			<div class="share">
				<div class="list">
					<!-- <img v-for="image in shareImages" :key="image" :src="require(`@/assets/images/${image}`)" alt=""> -->
					<video :ref="image" v-for="(image, index) in videolist" :key="index" muted preload autoplay loop
						controls="false" type="video/mp4" width="100%" webkit-playsinline="true" x-webkit-airplay="allow"
						playsinline="" x5-video-player-type="h5" x5-video-orientation="portrait"
						x5-video-player-fullscreen="portraint" :src="image">
						对不起，您的手机不支持本系统
					</video>
					<div class="padding-4"></div>

				</div>
			</div>
		</div>
		<Start></Start>
	</div>
</template>
<script>
import Start from '@/components/Start.vue'
export default {
	components: { Start },
	data() {
		return {
			videolist: [],
			showMoreBtn: true,
			caseList: [],
			caseSet: [],
			shareImages: ['share1.png', 'share2.png', 'share3.png', 'share4.png', 'share5.png',]
		}
	},
	mounted() {
		this.getCaseList()
		this.getCaseSet()
	},

	methods: {
		//&do=json&sjk=caselist
		async getCaseList() {
			let fdata = { do: 'json', sjk: 'caselist', orderby: 'orderid asc' }
			let res = await this.$api.funk(fdata)
			this.caseList = res
		},

		async getCaseSet() {
			let fdata = { do: 'getset', goto: 'caseset', orderby: 'orderid asc' }
			let res = await this.$api.funk(fdata)
			this.caseSet = res
			const casevideos = [res.bootvideo1, res.bootvideo2, res.bootvideo3, res.bootvideo4, res.bootvideo5];
			console.log(casevideos);
			this.videolist = casevideos
		},

		// 初始化
		initVideo(videoList) {
			videoList.forEach((item, index) => {
				this.$refs['video' + index].controls = false
			})
		},

		async getCaseListAll() {
			this.showMoreBtn = false
			let fdata = { do: 'json', sjk: 'caselist', orderby: 'orderid asc', limit: 10 }
			let res = await this.$api.funk(fdata)
			this.caseList = res
		}
	}
}
</script>
<style lang="scss" scoped>
.case-wrapper {
	.speech {
		margin-bottom: 0.4rem;

		img {
			width: 100%;
			display: block;
		}
	}


	.content {
		width: 100%;
		height: 4.2rem;
		background: url('~@/assets/images/banner/case.png')no-repeat top center /100% 100%;
		background-size: cover;
		position: relative;

		.main {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			flex-direction: column;
		}

		.left {
			width: 4.53rem;
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.right {
			width: 4.53rem;
			position: absolute;
			top: 0;
			right: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.introduce-content {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.64rem;
			line-height: 0.64rem;
			color: #000000;
			text-align: center;
			width: 100%;

			span {
				color: #E02E43;
			}
		}

		.tips {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.34rem;
			text-align: center;
			color: #000000;
			margin-top: 0.16rem;
		}
	}

	.custom-case-wrapper {
		margin-top: 0.8rem;
		padding: 0 0.6rem;

		.case-content {
			border-radius: 0.1rem;
			background: #FAF5F5;
			display: flex;
			margin-bottom: 0.8rem;
			height: 4.48rem;

			.case-img {
				width: 100%;
				height: 100%;
				overflow: hidden;
				border-radius: 0.1rem 0 0 0.1rem;

				img {

					width: 100%;
					height: 100%;
					object-fit: cover;
					display: block;
				}
			}

			.case-conten-right {
				width: 6.50rem;
				padding-left: 0.3rem;
				padding-right: 0.40rem;
				padding-top: 0.4rem;
				height: 100%;

				.image {
					width: 1.50rem;
					height: 0.7rem;
					display: block;
				}

				.quote {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
					width: 5.30rem;
					height: 1.95rem;
					padding-top: 0.24rem;
				}

				.author-info {
					display: flex;
					justify-content: space-between;
					align-items: flex-end;
					margin-top: 0.3rem;

					.author {
						font-family: 'PingFang HK';
						font-style: normal;
						font-weight: 600;
						font-size: 0.2rem;
						line-height: 0.28rem;
						color: #000000;
					}

					.trial {
						background: #E02E43;
						border-radius: 8px;
						font-family: 'PingFang HK';
						font-style: normal;
						font-weight: 600;
						font-size: 0.24rem;
						line-height: 0.64rem;
						padding: 0rem 0.4rem;
						color: #FFFFFF;
					}
				}
			}
		}

		.more-button {
			width: 2.72rem;
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.32rem;
			color: #E02E43;
			border: 1px solid #E02E43;
			border-radius: 0.08rem;
			text-align: center;
			padding: 0.24rem 0rem;
			margin: 0 auto;
		}
	}

	.share-wrapper {
		background-image: url('/assets/images/gradientBackground.png');
		background-size: cover;
		background-position: center;
		position: relative;

		.next {
			display: none;
		}

		.title {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.4rem;
			line-height: 0.56rem;
			color: #000000;
			margin-top: 1.06rem;
			margin-bottom: 0.56rem;
			text-align: center;
		}

		.share {
			width: 100%;
			padding-bottom: 0.4rem;



			.list {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			img {
				width: 2.90rem;
				height: 4.36rem;
				margin-right: 0.2rem;
				display: block;
				object-fit: cover;
				border-radius: 0.1rem;
			}

			video {
				object-fit: cover;
				width: 2.4rem;
				height: 4.26rem;
				border-radius: 0.24rem;
				overflow: hidden;
			}

			//所有控件
			video::-webkit-media-controls-enclosure {
				display: none;
			}

			video::-webkit-media-controls {
				display: none;
			}

			/* 全屏按钮 */
			video::-webkit-media-controls-fullscreen-button {
				display: none;
			}

			/* 播放按钮 */
			video::-webkit-media-controls-play-button {
				display: none;
			}

			/* 进度条 */
			video::-webkit-media-controls-timeline {
				display: none;
			}

			/* 观看的当前时间 */
			video::-webkit-media-controls-current-time-display {
				display: none;
			}

			/* 剩余时间 */
			video::-webkit-media-controls-time-remaining-display {
				display: none;
			}

			/* 音量按钮 */
			video::-webkit-media-controls-mute-button {
				display: none;
			}

			video::-webkit-media-controls-toggle-closed-captions-button {
				display: none;
			}

			/* 音量的控制条 */
			video::-webkit-media-controls-volume-slider {
				display: none;
			}

			/* 所有控件 */
			video::-webkit-media-controls-enclosure {
				display: none;
			}


			.padding-4 {
				display: none;
				width: 3.74rem;
				height: 6.64rem;
			}
		}
	}
}

@media (max-width: 750px) {
	.case-wrapper .custom-case-wrapper .case-content {
		height: auto;
		display: block;
	}

	.case-wrapper .conten {
		background: url('~@/assets/images/cover-img.png')no-repeat top center /100% 100%;
	}

	cover-img.png .case-wrapper .custom-case-wrapper .case-content .case-img {
		width: 100%;
		border-radius: 0.1rem 0.1rem 0 0;
	}

	.case-wrapper .custom-case-wrapper .case-content .case-conten-right {
		width: 100%;
		margin: 0;
		padding: 0.4rem 0.3rem;
	}

	.case-wrapper .share-wrapper {
		padding-right: 0;
	}

	.case-wrapper .share-wrapper .share {
		width: 100%;
		overflow-x: scroll;
		margin-bottom: 1.6rem;
	}

	.case-wrapper .share-wrapper .share .list {
		display: flex;
		justify-content: flex-start;
		padding-right: 0.4rem;
		margin-right: 0.4rem;
		width: 100%;
	}

	.case-wrapper .share-wrapper .share .list img {
		width: 3.74rem;
		height: 6.64rem;
		flex: 1;
	}

	.case-wrapper .share-wrapper .share .list video {
		width: 3.74rem;
		height: 6.64rem;
		flex-shrink: 0;
		margin-right: 0.3rem;
	}

	.case-wrapper .share-wrapper .share .padding-4 {
		display: flex;
		flex: 1;
		padding: 0.2rem;
	}

	.case-wrapper .share-wrapper .title {
		font-size: 0.8rem;
		line-height: 0.8rem;
		margin-top: 3.2rem;
		margin-bottom: 0.6rem;
	}

	.content .left,
	.content .right {
		display: none;
	}

	.case-wrapper .content .tips {
		font-size: 0.28rem;
		line-height: 0.38rem;

	}

	.case-wrapper .custom-case-wrapper .case-content .case-conten-right .quote {
		font-size: 0.28rem;
		line-height: 0.34rem;
	}

	.case-wrapper .share-wrapper .next {
		display: block;
		width: 0.8rem !important;
		height: 0.8rem !important;
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto 0;
		right: 0.1rem;
		transform: translateY(0.3rem);
	}
}
</style>